@if (isLoading && !messageContent) {
  <loading-indicator [loadingMessage]="'Loading message content, please wait...'"></loading-indicator>
} @else {
  <public-page-template [contentTemplate]="previewContent"></public-page-template>
}


<ng-template #previewContent>
  <preview-sent-email [message]="messageContent"  [isDialog]="false"></preview-sent-email>
</ng-template>